import { CheckCircledIcon } from '@radix-ui/react-icons';
import type { OptionRendererProps } from '@src/components/combobox/Combobox';
import { cn } from '@/lib/utils';

// LF360-2015: a picker row for an article - the whole title wraps and a
// selected article is marked. Hovering the row previews it beside the list.
export const ArticleOptionRenderer = ({ isValueSelected, option }: OptionRendererProps) => (
  <div className={cn('flex w-full items-start', { 'font-medium text-primary': isValueSelected })}>
    <div className="w-6 min-w-6 pt-0.5">
      {isValueSelected && <CheckCircledIcon/>}
    </div>
    <div className="min-w-0 flex-1 break-words">
      {option.label}
      {isValueSelected && <span className="ml-2 text-xs font-normal text-label-foreground">Selected</span>}
    </div>
  </div>
);
